import React, { Component } from 'react'
import { Button, Modal, Message, Header} from 'semantic-ui-react'

export default class ErrorModal extends Component {

  render() {
    const { errorMessage } = this.props;
    return(
      <Modal
        open={true}
        onClose={this.props.hideDetailsModal}
        centered={false}
        size='small'
      >
        <Header color="red" icon='warning' content='Error' />
        <Modal.Content>
          <Message negative>
              <p>{errorMessage}</p>
            </Message>
        </Modal.Content>
        <Modal.Actions>
          <Button color='red' onClick={this.props.hideDetailsModal}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
